import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("c7wXz"), parcelRequire.load("kKZyw"), parcelRequire.load("5pEDO"), parcelRequire.load("cfjIz"), parcelRequire.load("c6gg0"), parcelRequire.load("k9IXU")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("c7wXz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("kKZyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("5pEDO")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("cfjIz")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c6gg0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k9IXU")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
